// -----------------------------------------------------------
// FloraIQ - PointCloudReportsGrid — Aba Relatórios
// -----------------------------------------------------------

import { reports3D } from "@/mocks/pointcloud";

export default function PointCloudReportsGrid() {
  const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
    disponivel: { label: "Disponível", color: "text-green-600", bg: "bg-green-50" },
    processando: { label: "Processando", color: "text-amber-600", bg: "bg-amber-50" },
    pendente: { label: "Pendente", color: "text-gray-500", bg: "bg-gray-50" },
  };

  const iconMap: Record<string, string> = {
    "Relatório de Levantamento 3D": "ri-flight-takeoff-line",
    "Relatório de Nuvem de Pontos": "ri-stack-line",
    "Relatório de Métricas Arbóreas 3D": "ri-plant-line",
    "Relatório de Alturas Extraídas": "ri-ruler-line",
    "Relatório de Copas Estimadas": "ri-bubble-chart-line",
    "Relatório de Interferências 3D": "ri-error-warning-line",
    "Relatório de Comparação Temporal": "ri-contrast-2-line",
    "Relatório de Qualidade dos Metadados": "ri-check-double-line",
    "Relatório de Cobertura Vegetal 3D": "ri-landscape-line",
    "Relatório de Modelo 3D da Arborização": "ri-shapes-line",
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {reports3D.map((r) => {
        const st = statusConfig[r.status] || statusConfig.pendente;
        const icon = iconMap[r.title] || "ri-file-chart-line";
        return (
          <div key={r.id} className="bg-white rounded-card border border-background-200/70 p-4 hover:shadow-sm transition-shadow flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
                <i className={`${icon} text-blue-600 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-bold text-foreground-900 font-heading leading-tight">{r.title}</h5>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{r.description}</p>
              </div>
            </div>
            <div className="mt-auto pt-3 border-t border-background-100/50 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`inline-flex items-center px-2 py-0.5 text-[10px] font-medium rounded-full ${st.bg} ${st.color}`}>
                  {st.label}
                </span>
                {r.ultimaGeracao !== "-" && (
                  <span className="text-[10px] text-foreground-400">{new Date(r.ultimaGeracao + "T00:00:00").toLocaleDateString("pt-BR")}</span>
                )}
              </div>
              <div className="flex items-center gap-1">
                {r.status === "disponivel" ? (
                  <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors cursor-pointer" title="Visualizar" aria-label="Visualizar">
                    <i className="ri-eye-line text-foreground-500 text-sm"></i>
                  </button>
                ) : (
                  <button className="text-[10px] px-2.5 py-1.5 rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                    Gerar
                  </button>
                )}
                <button className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors cursor-pointer" title="Exportar" aria-label="Exportar">
                  <i className="ri-download-2-line text-foreground-500 text-sm"></i>
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}